import PropTypes from "prop-types";
import React from "react";
import styles from "./CommonRadioOpcoes.module.css";
import Hint from "../../Common/Hint";

/**
 * Checkbox reutilizável para valores true ou false que exibe duas opções
 */
function CommonRadioOpcoes({
  label,
  id,
  upValue,
  lowValue,
  upOnChange,
  lowOnChange,
  upText,
  lowText,
  required = false,
  disabled = false,
  hint = false,
  hintIcon = null,
  ...props
}) {
  return (
    <>
      {label && (
        <>
          <label htmlFor={id} className={styles.label}>
            {label}
          </label>
          {required && <span style={{ color: "#f46a6a" }}> *</span>}
          {hint && <Hint hint={hint} icon={hintIcon} />}
        </>
      )}
      <div
        style={{ marginBottom: "0.25rem" }}
        className={`${styles.formCheck} ${disabled && styles.disabled}`}
      >
        <input
          className={styles.input}
          type="radio"
          name={id}
          id={`${id}Up`}
          onChange={disabled ? null : upOnChange}
          checked={upValue}
          disabled={disabled}
          {...props}
        />
        <label className={styles.inputLabel} htmlFor={`${id}Up`}>
          {upText}
        </label>
      </div>
      <div className={`${styles.formCheck} ${disabled && styles.disabled}`}>
        <input
          className={styles.input}
          type="radio"
          name={id}
          id={`${id}Low`}
          onChange={disabled ? null : lowOnChange}
          checked={lowValue}
          disabled={disabled}
          {...props}
        />
        <label className={styles.inputLabel} htmlFor={`${id}Low`}>
          {lowText}
        </label>
      </div>
    </>
  );
}

CommonRadioOpcoes.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  upValue: PropTypes.bool.isRequired,
  lowValue: PropTypes.bool.isRequired,
  upOnChange: PropTypes.func.isRequired,
  lowOnChange: PropTypes.func.isRequired,
  upText: PropTypes.string.isRequired,
  lowText: PropTypes.string.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  hint: PropTypes.string,
  hintIcon: PropTypes.string,
};

export default CommonRadioOpcoes;
